import BankLogoComponent from "@portal/components/atoms/bankLogo";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";

import { NORNE_CENTERID } from "@portal/assets/banks";
import { StartPageLanguage } from "../../startpage/components";
import RobotHeaderText from "../robotHeaderText";
import { ProgressBarComponent } from "@portal/components/atoms/v2/progressBar";

interface Props {
  pageIndex: number;
  isDefaultLanguage: boolean;
  centerId: string;
  isIFrame: boolean;
}

/**
 * The header component for the application shows the header for each page, and the progress bar.
 * @param interface
 * @returns a progress bar and a header text.
 */
export const HeaderComponent = ({ pageIndex, isDefaultLanguage, centerId, isIFrame }: Props) => {
  const isFirstPage = pageIndex === 0;
  const backgroundColor = GetHeaderBackgroundColorForRobot(isFirstPage, isIFrame, centerId);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const headers = [
    "",
    texts.PAGE_1_HEADER,
    texts.PAGE_2_HEADER,
    texts.PAGE_3_HEADER,
    texts.PAGE_4_HEADER,
    texts.PAGE_5_HEADER,
    texts.PAGE_6_HEADER,
    texts.PAGE_7_HEADER,
    texts.PAGE_8_HEADER,
    texts.PAGE_9_HEADER,
    texts.PAGE_10_HEADER,
    texts.PAGE_11_HEADER,
    texts.PAGE_12_HEADER,
    texts.PAGE_13_HEADER,
    texts.PAGE_14_HEADER,
    texts.PAGE_15_HEADER,
    texts.PAGE_16_HEADER,
    texts.PAGE_17_HEADER,
  ];

  const renderFirstPageHeader = (isIFrame: boolean) => (
    <div
      style={{
        backgroundColor: `${backgroundColor}`,
      }}
      className="flex flex-col items-center gap-2 sm:gap-4 w-full sm:rounded-t-xl border-b border-grey h-20"
    >
      <div className="flex w-full justify-between">
        <div className="flex mt-2 ml-5">{isIFrame && <BankLogoComponent centerId={centerId} />}</div>
        <div className="flex mr-3.5 mt-3.5">
          <StartPageLanguage
            isPrimaryLanguage={isDefaultLanguage}
            primaryLanguageText={texts.TEXT_LANGUAGE_A}
            secondaryLanguageText={texts.TEXT_LANGUAGE_B}
            isIFrame={isIFrame}
            centerId={centerId}
          />
        </div>
      </div>
    </div>
  );

  if (isFirstPage) return renderFirstPageHeader(isIFrame);

  return (
    <div className="flex w-[calc(100%+2px)] sticky top-0 h-20 sm:h-24 z-10 border border-grey rounded-t-xl">
      <div
        style={{
          backgroundColor: `${backgroundColor}`,
        }}
        className="flex flex-col items-center gap-2 sm:gap-4 w-full sm:rounded-t-xl h-20 sm:h-auto"
      >
        <div className="flex flex-col w-full">
          <div className="flex justify-center mt-1">
            <ProgressBarComponent pageIndex={pageIndex} totalPages={17} />
          </div>
          <div className="flex mt-1 justify-center text-robotHeaderBackgroundText">
            <RobotHeaderText text={headers[pageIndex]} />
          </div>
        </div>
      </div>
    </div>
  );
};

const GetHeaderBackgroundColorForRobot = (isFirstPage: boolean, isIFrame: boolean, centerId: string) => {
  if (isFirstPage && isIFrame) {
    if (centerId === NORNE_CENTERID) return "var(--color-primary)";
    if (centerId === "2220") return "#002d4b";
    if (centerId === "9820") return "#0047ba";
    if (centerId === "4589" || centerId === "4730" || centerId === "4605") return "#00353d";
    return "var(--color-greyLight)";
  }
  return "var(--color-primary)";
};
